
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class AntiMatterEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(40 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2.5;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2.5;
                
                // Rapidly flickering particles
                const flicker = this.pseudoRandom(i + Math.floor(curTime * 20));
                if (flicker > 0.7) {
                    ctx.save();
                    ctx.globalAlpha = (flicker - 0.7) * 3 / (layerIndex + 1);
                    ctx.beginPath();
                    ctx.arc(rx, ry, 5 * scale, 0, Math.PI * 2);
                    ctx.fill();
                    
                    // Crosshair on particle
                    ctx.lineWidth = 1 * scale;
                    ctx.strokeStyle = pc.color;
                    ctx.beginPath();
                    ctx.moveTo(rx - 10, ry); ctx.lineTo(rx + 10, ry);
                    ctx.moveTo(rx, ry - 10); ctx.lineTo(rx, ry + 10);
                    ctx.stroke();
                    ctx.restore();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
